import React from 'react';
import { useNavigate } from 'react-router-dom';
import './Settings.css';
import Cookies from 'js-cookie';
   
const Settings = () => {
  const navigate = useNavigate();
  const handleNavigation = (route) => {
    navigate(route);
  };

  return (
    <section className="main_content">
      <div className="container">
        <h1 className="page-title">الإعدادات</h1>
        <ul className="settings-list">
          <li className="settings-item" onClick={() => handleNavigation('/admin/add-menu')}>
            <span className="arrow-icon">›</span>
            إضافة قائمة جديدة
          </li>
          <li className="settings-item" onClick={() => handleNavigation('/admin/edit-menu')}>
            <span className="arrow-icon">›</span>
            تعديل قائمة موجودة
          </li>
          <li className="settings-item" onClick={() => handleNavigation('/admin/add-item')}>
            <span className="arrow-icon">›</span>
            إضافة صنف لقائمة موجودة
          </li>
          <li className="settings-item" onClick={() => handleNavigation('/admin/schedule')}>
            <span className="arrow-icon">›</span>
            جدول المطاعم
          </li>
          <li className="settings-item" onClick={() => handleNavigation('/admin/menus')}>
            <span className="arrow-icon">›</span>
            قوائم المطاعم
          </li>
          <li className="settings-item" onClick={() => handleNavigation('/admin/total-orders')}>
            <span className="arrow-icon">›</span>
            عرض إجمالي الطلبات
          </li>
          <li className="settings-item" onClick={() => handleNavigation('/admin/employee-orders')}>
            <span className="arrow-icon">›</span>
            عرض إجمالي الطلبات لكل موظف
          </li>
          <li className="settings-item" onClick={() => handleNavigation('/admin/period-orders')}>
            <span className="arrow-icon">›</span>
            إجمالي الطلبات خلال فترة
          </li>
          <li className="settings-item" onClick={() => handleNavigation('/admin/employee-statement')}>
            <span className="arrow-icon">›</span>
            كشف طلبات الموظفين
          </li>
        </ul>
      </div>
    </section>
  );
};

export default Settings;
